/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Recipient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AddProfessional from './AddProfessional/index'
import Options from './Options/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Recipient({
  children,
  viewPath = "/DesignSystem/LetterRecipientPicker/Content/Recipient",
  onChange,
  patientId
  
}) {
let pickerRecipientsValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'recipients',
})
let pickerRecipientsLengthValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'recipients.length',
})
let pickerRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'recipient_id',
})
let pickerRecipientIdChangeData = fromData.useDataChange({ viewPath,
context: 'picker',
path: 'recipient_id',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 placeholder="Recipient"
 marginTop={0}
 alignSelf="auto"
 data="picker.recipients"
 from={pickerRecipientsValueData}
 required={true}
 data="picker.recipients.length"
 disabled={!pickerRecipientsLengthValueData}
 allowEmptyChoice={false}
 data="picker.recipient_id"
 value={pickerRecipientIdValueData}
 onChange={pickerRecipientIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Recipient"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
 autoFocus={true}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<Options
{...childProps}
  viewPath={`${viewPath}/Options`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
<AddProfessional
  viewPath={`${viewPath}/AddProfessional`}
 patientId={patientId}
/>
{children}
</React.Fragment>)
}